import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import { useQuery } from '@apollo/react-hooks';

import compose from 'lodash/flowRight';
import Controller from '../signupImpressions/SignupImpressionsController';
import GET_SIGNUP_IMPRESSIONS from '../../../../GraphQl/Queries/GET_SIGNUP_IMPRESSIONS';
import CURRENT_USER from '../../../../GraphQl/Queries/CURRENT_USER';
import Spinner from '../../../../../platform/shared/designSystem/components/Spinner';

const SignupImpressionsLoader = ({ children, campaignOrderId, reportName, signupId }) => {
  const { loading, data } = useQuery(GET_SIGNUP_IMPRESSIONS, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      campaignOrderId,
      reportName,
      signupId,
    },
  });

  if (loading) {
    // Compact expanded-row loading pattern — matches the V2 signup +
    // V1 transaction impression loaders. Tight expanded-row context —
    // a full-height loading block would push the row taller than the
    // content it's waiting for.
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Spinner size="default" />
      </div>
    );
  }

  const impressions = data && data.getSignupImpressions;

  return <Controller impressions={impressions}>{children}</Controller>;
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withApollo(SignupImpressionsLoader));
